/**
 * The loop mark — a thin ring with four cardinal points. Used large and faint
 * as hero atmosphere, small as a bullet in the standards strip.
 */
export function LoopRing({
  size = 16,
  color = "var(--primary-500)",
  strokeWidth = 1.5,
  className,
}: {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
}) {
  const r = size / 2 - 4;
  const c = size / 2;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      className={className}
      aria-hidden
    >
      <circle cx={c} cy={c} r={r} stroke={color} strokeWidth={strokeWidth} />
      <circle cx={c} cy={4} r={3} fill={color} />
      <circle cx={size - 4} cy={c} r={3} fill={color} />
      <circle cx={c} cy={size - 4} r={3} fill={color} />
      <circle cx={4} cy={c} r={3} fill={color} />
    </svg>
  );
}
